<template>
  <div class="file-badge d-inline-flex align-center mr-2" :class="{small}">
    <div class="icon-wrapper">
      <v-icon v-show="!loading" :color="iconColor" :size="small ? 20: 32" class="file-icon">
        {{ fileIcon }}
      </v-icon>

      <v-progress-circular v-if="loading" indeterminate color="primary" size="20" class="absolute spinner" />

      <v-icon v-else-if="error" small color="red" class="status-icon">
        mdi-alert-circle
      </v-icon>

      <v-icon v-else-if="loaded" small color="green" class="status-icon">
        mdi-check-circle
      </v-icon>

      <v-icon v-if="closable" small color="grey darken-1" class="close-icon" @click="$emit('close')">
        mdi-close
      </v-icon>
    </div>
    <span v-if="!noName" class="file-name ml-1">
      {{ name }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    loading: Boolean,
    loaded: Boolean,
    error: Boolean,
    closable: Boolean,
    small: Boolean,
    noName: Boolean,
  },
  computed: {
    type() {
      const parts = this.name?.split('.');
      return parts?.length > 1 ? parts.pop().toLowerCase() : '';
    },
    fileIcon() {
      switch (this.type) {
        case 'pdf': return 'mdi-file-pdf-box';
        case 'doc':
        case 'docx': return 'mdi-file-word-box';
        case 'xls':
        case 'xlsx': return 'mdi-file-excel-box';
        case 'txt': return 'mdi-file-document-outline';
        default: return 'mdi-file';
      }
    },
    iconColor() {
      switch (this.type) {
        case 'pdf': return 'red darken-1';
        case 'doc':
        case 'docx': return 'blue darken-1';
        case 'xls':
        case 'xlsx': return 'green darken-2';
        default: return 'green _darken-1';
      }
    }
  }
};
</script>

<style scoped>
.file-badge {
  background: transparent;
  padding: 4px 4px;
  border-radius: 8px;
  position: relative;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.file-badge.small {
  padding: 1px;
  border-radius: 2px;
}

.icon-wrapper {
  position: relative;
  width: 32px;
  height: 32px;
}
.file-badge.small .icon-wrapper {
  width: 20px;
  height: 20px;
}

.file-icon {
  z-index: 1;
}

.spinner {
  top: 6px;
  left: 6px;
  position: absolute;
  z-index: 2;
}

.status-icon {
  position: absolute !important;
  top: -6px;
  right: -6px;
  background: white;
  border-radius: 50%;
  z-index: 3;
}

.close-icon {
  position: absolute !important;
  top: -10px;
  right: -10px;
  /* background: white; */
  border-radius: 50%;
  z-index: 3;
  cursor: pointer;
}

.file-name {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
